import { useMemo } from 'react'
import { useFeatureFlag } from './useFeatureFlag'
import { useAuthProvider } from '@maui-mf/common-react'

export const useDuetAiFeature = () => {
  const isFeatureEnabled = useFeatureFlag('duet_ai_feature')

  const { claims = {} } = useAuthProvider()

  const isl = useMemo(() => {
    return claims.isl || []
  }, [claims])

  const isFusion = isl.includes('INTEL_RBI_FUS')
  const isSecOps = !isFusion && isl.includes('INTEL_RBI_OPS')

  return {
    isFeatureEnabled,
    isUserEntitled: isSecOps || isFusion
  }
}
